module.exports = __webpack_public_path__ + "img/address-foreign-tablet-2.8e835597.svg";